"use client";

import { useEffect } from "react";
import {
  useSignalRConnection,
  useSignalRConnectionState,
} from "./SignalRContext";
import { SIGNALR_METHODS } from "./events";
import { invokeIfConnected } from "./invokeIfConnected";

/**
 * Joins the practice's SignalR channel so the connection receives
 * practice-scoped events (e.g. ccof-card-changed). Re-invoked whenever the
 * connection (re)connects or the practice changes, and leaves the previous
 * practice's channel on cleanup.
 */
export function usePracticeChannel(practiceId: string): void {
  const connection = useSignalRConnection();
  const isConnected = useSignalRConnectionState();

  useEffect(() => {
    if (!connection || !isConnected) return;

    invokeIfConnected(
      connection,
      SIGNALR_METHODS.JOIN_PRACTICE_CHANNEL,
      practiceId,
    );

    return () => {
      invokeIfConnected(
        connection,
        SIGNALR_METHODS.LEAVE_PRACTICE_CHANNEL,
        practiceId,
      );
    };
  }, [connection, isConnected, practiceId]);
}
